import { createReducer, on } from '@ngrx/store';

import { UserActions } from './actions';
import { UserState } from './feature';

export const initialUserState = (): UserState => ({
  roughagePlusAppRole: undefined,
});

const UserReducer = createReducer(
  initialUserState(),
  on(UserActions.setRoughagePlusAppRole, (state, { role }) => ({
    ...state,
    roughagePlusAppRole: role,
  })),
);

export default UserReducer;
